import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService, ShowHideInput, PatientService } from '../../shared';
import { environment } from '../../shared/config/app-config';


@Component({
  templateUrl: 'helpdesk.component.html',
  styleUrls: ['../style.component.css']


})

export class HelpdeskComponent implements OnInit {
  public data: Object;
  params: any;
  path: any = {};
  public myobj: any = {};
  public myobj1: any = {};
  public apiurl: any = environment.api_url;
  patpwd: any = {};
  patpwd1: any = {};
  patswfid: any;
  CurrentUser: any;
  constructor(

    private activeroute: ActivatedRoute,
    private routers: Router,
    private patientservice: PatientService,
    private userService: UserService,

  ) {

  }




  ngOnInit() {
    this.activeroute.params.subscribe(params => {
      this.params = params

      //////console.log(this.params)
    });

    /* this.patientservice
    .getname(this.params.patid)
    .subscribe(
      data => {
  
        this.path = data;
      }
    ); */
    if (window.localStorage['pwd']) {
      this.myobj = JSON.parse(window.localStorage['pwd']);

      this.myobj1 = JSON.stringify(this.myobj);
      // ////console.log(this.myobj1)
      // ////console.log(this.myobj.userFnLn)
    }
    else {
      // ////console.log("logout")
      this.routers.navigate([`/login`])
    }
    if (window.localStorage['patpwd']) {
      this.patpwd = JSON.parse(window.localStorage['patpwd']);

      this.patpwd1 = JSON.stringify(this.patpwd);
      // ////console.log(this.patpwd.newpswd)
      // ////console.log(this.patpwd1)
    }

  }

  login() {

    let credentials = {
      'username': this.myobj.userEmail,
      'password': btoa(this.patpwd.newpswd),
      'captcha': '',
      'mode': '',
      'usermode': localStorage.getItem('userMode') ? atob(localStorage.getItem('userMode')) : 'p',
      'forcelogin': 'false',
      "language": this.userService.selectedLang()
    }
    this.userService.attemptAuth(credentials)
      .subscribe(
        data => {
          //////console.log(data);
          if (data.operationStatus == "SUCCESS") {

            this.userService.postuserinfoid(1, data.item.userAccountId).subscribe(
              data => {
                this.patswfid = data[0].patientStageWorkflow[0].patSWFId
                // ////console.log( this.patswfid)
              }
            )
            this.routers.navigate(['/patient/dashboard/' + this.patswfid])

          } else {


          }

        }
      );
  }
}






